import { render, staticRenderFns } from "./BuyOrderPersonForm.vue?vue&type=template&id=0d4f8224&"
import script from "./BuyOrderPersonForm.vue?vue&type=script&lang=js&"
export * from "./BuyOrderPersonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports